import React, { useState, useRef, useEffect } from "react";
import { Menu, X } from 'lucide-react';

const Navbar = ({ name }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [qrCode, setQrCode] = useState('');
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const storedQrCode = localStorage.getItem('qrCode');
    if (storedQrCode) {
      setQrCode(storedQrCode);
    }
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userName");
    window.location.href = "/";
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  const downloadQRCode = () => {
    const link = document.createElement('a');
    link.href = `data:image/png;base64,${qrCode}`;
    link.download = 'QRCode.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <nav className="bg-[#D6D1D11A] min-h- h-16 py-4 px-8 rounded-full flex justify-between items-center max-w-7xl mx-auto m-4 z-10">

        <a href="/">
          <div className="flex-shrink-0 flex items-center justify-center">
            <img
              className="h-8 w-auto object-contain"
              src="./logo.png"
              alt="Your Company"
              id="logo"
            />
          </div>
        </a>

        <div className="hidden md:flex space-x-6">
          {/* Other links */}
        </div>

        <div className="hidden md:block">
          <div className="relative" ref={dropdownRef}>
            <a href="https://sigmamozak.com/">
              <div className="flex-shrink-0 flex items-center justify-center">
                <img
                  className="h-8"
                  style={{ width: "120px", height: "60px" }}
                  src="./sigma_logo.png"
                  alt="Sigma Mozak"
                  id="sigma-logo"
                />
              </div>
            </a>
          </div>
        </div>
        {/*
            <button onClick={toggleDropdown} className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-5 py-2 rounded-full font-semibold hover:from-yellow-500 hover:to-orange-600">
              Dr.{name}
            </button>
            {dropdownOpen && (
              <div className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-md py-1">
                <button onClick={downloadQRCode} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  Download QR Code
                </button>
                <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  Logout
                </button>
              </div>
            )}
            */}

        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-blue-700">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isOpen && (
          <div className="absolute top-16 left-0 right-0 bg-white p-4 md:hidden z-10">
            <div className="flex flex-col space-y-4">
              <button onClick={downloadQRCode} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                Download QR Code
              </button>
              <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                Logout
              </button>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
